import { MaterialService } from './../../service/material.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KiwixiService } from '../../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import 'rxjs';

@Injectable()
export class OutlookLingueoService extends KiwixiService {

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  downloadIcs(_url, _filename) {
    const header = this.createHttpClientAuthorizationHeader();
    this._http.get(_url, { headers: header, responseType: 'arraybuffer' })
      .subscribe((file) => {
        this.downloadFile(_filename, file);
      });
  }

}
